import { types } from 'mobx-state-tree'

const UserResourceTagModel = types.model('UserResourceTagModel', {
  id: types.optional(types.integer, 0),
  tagName: types.maybeNull(types.string),
  resourceId: types.optional(types.integer, 0),
})

export default UserResourceTagModel
